<template>
  <div class="centent">
    <div :class="{ sFivesContAnim: sFivesContAnim }" class="titlefont">
      <div class="titleAnimation">
        <div class="title">实训作业及时批改&其他辅助训练</div>
      </div>
    </div>
    <div class="cont" :class="{ sFivesContAnim: sFivesContAnim }">
      <div class="contInfo itemA">
        <div class="conLeft">
          <div class="teachingMethod" :style="methodsty">
            <img src="./../images/sxPic.jpg" />
            <img src="./../images/sqPic.jpg" />
            <img src="./../images/wxPic.jpg" />
          </div>
          <ul class="item">
            <li
              v-for="(item, index) in fifthScreen"
              :key="item.id"
              @click="fifthmouseOver(index)"
              @mouseover="fifthmouseOver(index)"
              @mouseleave="fifthmouseLeave(index)"
              :class="index === fifthActive ? 'fivesActive' : ''"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="conRight">
          <ul>
            <li>
              <div class="icon"></div>
              <div class="tit">授课动态调整</div>
              <div class="text">
                每天学员对讲师进行教学反馈，<br/> 根据评分调整授课进度
              </div>
              <div class="line"></div>
            </li>
            <li>
              <div class="icon"></div>
              <div class="tit">磨炼职场技能</div>
              <div class="text">
                每天学员以演讲形式+PPT展示，锻<br/>炼学员语言表达能力等职场技能
              </div>
              <div class="line"></div>
            </li>
            <li>
              <div class="icon"></div>
              <div class="tit">增长工作本领</div>
              <div class="text">
                每周学员统一以邮件形式提交周<br/>报，锻炼学员话术及工作展示
              </div>
              <div class="line"></div>
            </li>
            <li>
              <div class="icon"></div>
              <div class="tit">增加学员能力</div>
              <div class="text">
                学员寻找本周要事和新闻，锻炼追<br/>踪/点燃热点能力
              </div>
              <div class="line"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fifthScreen: {
      type: Array,
      required: true,
      default: () => {},
    },
    sFivesContAnim: {
      type: Boolean,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      fifthActive: 2,
    };
  },
  computed: {
    methodsty() {
      let num = Number(this.fifthActive) * 300;
      return `transform: translateX(-${num / 3}%);transition: all 0.3s;`;
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 实训作业及时批改&其他辅助训练鼠标经过事件
    fifthmouseOver: function (index) {
      this.fifthActive = index;
    },
    // 实训作业及时批改&其他辅助训练鼠标移出事件
    fifthmouseLeave: function (index) {
      this.fifthActive = index;
    },
    sevHandleOver(item) {
      this.dialogData = item;
      console.log(item);
    },
    sevHandleOut() {
      this.dialogData = {};
    },
  },
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
